import DefaultStages from './DefaultStages';

export default DefaultStages
;